import React from 'react';
const rio = require('../../assets/rio.jpg');
export default class Updated extends React.Component {

    render() {
        return (
            <div className="appLoading">
                <h3>PAYMENT ADDED</h3>
                <div className="rio">
                    <img
                        className="rio"
                        src={rio}
                        aria-hidden
                        alt="background image"
                    />
                </div>


                <div className="aerotubos">
                    <img
                        className="aerotubos"
                        aria-hidden
                        alt="background image"
                    />

                </div>

                <div className="appLoadingText">

                    <h1>PAYMENT UPDATED</h1>

                    <p>Press escape to return</p>
                    <br/><br/><br/><br/><br/><br/>
                    <br/><br/><br/><br/><br/><br/>
                    <p>
                        Developed by Cloud Computing Team
                    </p>
                    <p>
                        Royal Melbourne Institute of Technology
                    </p>
                    <p>
                        Versão: 1.0
                    </p>
                </div>


            </div>
        )
    }
}


